import React from 'react';
import { Path, Svg } from 'react-native-svg';

interface IconProps {
  size?: number;
  color?: string;
}

export const SolarMagnifierIcon: React.FC<IconProps> = ({ size = 32, color }) => {
  const COLOR = color || '#7E74E4';
  return(
    <Svg width={size} height={size} viewBox="0 0 32 32" fill="none">
      <Path
        d="M26.666 26.667L29.3327 29.3337"
        stroke={COLOR}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <Path
        d="M8.99935 4.36157C10.8624 3.28382 13.0255 2.66699 15.3327 2.66699C22.3283 2.66699 27.9993 8.33805 27.9993 15.3337C27.9993 22.3293 22.3283 28.0003 15.3327 28.0003C8.33708 28.0003 2.66602 22.3293 2.66602 15.3337C2.66602 13.0265 3.28285 10.8634 4.36059 9.00033"
        stroke={COLOR}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </Svg>);
};
